import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { ManifactureListDetails, UserSupportModel } from "./type";

const initialState: UserSupportModel = {
  manufacturerList: [],
};

const UserSupportSlice = createSlice({
  name: "UserSupport",
  initialState,
  reducers: {
    setManufacturerList: (
      state: UserSupportModel,
      action: PayloadAction<ManifactureListDetails[]>,
    ) => {
      state.manufacturerList = action.payload;
    },
  },
});

export const { setManufacturerList } = UserSupportSlice.actions;

export default UserSupportSlice.reducer;
